<template>
    <v-container fluid style="color:grey" class="policeLato">
        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section v-if="isDesktop()">
          <div class="mt-5 pt-5 paralax-cover-image has-background-dim">
            <p class="paralax-cover-image-text">
            <div class="content_home" style="z-index: 1!important;">
              <h1 style="font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_auto.flotte_entreprise.faq_flotte.header_title[0]')}}</span></h1>
              <h1 style="font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('devis.devis_auto.flotte_entreprise.faq_flotte.header_title[1]')}}</span></h1>
            </div>
            </p>
          </div>
        </section>

        <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
        <section class="mt-5" v-if="isMobile()">
          <div class="paralax-cover-image_mobile has-background-dim_mobile">
            <p class="paralax-cover-image-text_mobile">
            <div class="content_home" style="z-index: 1!important;margin-top: 10%">
              <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('devis.devis_auto.flotte_entreprise.faq_flotte.header_title[0]')}}</span></h1>
              <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('devis.devis_auto.flotte_entreprise.faq_flotte.header_title[1]')}}</span></h1>
            </div>
            </p>
          </div>
        </section>

        <!-- Header Desktop-->
        <section class="mt-2 pt-5" v-if="isDesktop()">
            <div class="justify-content-center column pb-4">
                <div class="justify-content-center row">
                    <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">{{ $t('faq_flotte.title') }} <span class="ml-2 font-weight-regular" style="color: #666;">Excel</span></h1>
                </div>
                <div class="justify-content-center row">
                    <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
                </div>
            </div>
            <div class="text-center mb-8">
              <p class="mt-4 subheading font-weight-blod pl-md-5 pr-md-5" style="font-size: 16px;color: #000;">
                {{ $t('faq_flotte.instruction[0]') }}<br>
                {{ $t('faq_flotte.instruction[1]') }}
              </p>
            </div>
        </section>

        <!-- Header Mobile-->
        <section class="mt-5 pt-5" v-if="isMobile()">
            <div class="justify-content-center column pb-4">
                        <div class="justify-content-center row ml-3 mr-3">
                            <h1 class="justify-content-center row titre_for_desktop" style="font-size: 20px">{{ $t('faq_flotte.title') }} <br> Excel</h1>
                        </div>
                      
                        <div class="justify-content-center row">
                            <v-toolbar class="justify-content-center row underline_bar"></v-toolbar>
                        </div>
                    </div>
          <div class="text-center mb-8 ml-5 mr-5">
            <p class="mt-4 subheading font-weight-blod pl-md-5 pr-md-5" style="font-size: 16px;color: #000;">
              {{ $t('faq_flotte.instruction[0]') }}<br>
              {{ $t('faq_flotte.instruction[1]') }}
            </p>
          </div>
        </section>

        <!-- 4 Étapes -->
        <section class="mb-8 margin">
          <v-layout row wrap justify-center>
            <v-flex xs12 sm6 md3 lg3 class="text-center pa-3" v-for="(etape, index) in etapes" :key="index">
              <v-card class="elevation-2 pa-4" style="height: 200px; border-radius: 12px;">
                <div >
                    <i class="material-icons" aria-hidden="true" data-nosnippet  style="font-size: 50px;">{{etape.icon}}</i>
                </div>
                <h3 class="title font-weight-bold mb-2">{{ etape.titre }}</h3>
                <p class="body-2" style="color: #666;">{{ etape.description }}</p>
              </v-card>
            </v-flex>
          </v-layout>
        </section>

        <!-- Tableau des colonnes -->
        <section class="mb-8 mt-3" :class="{'margin': !isMobile(), 'margin_mobile': isMobile()}">
          <v-card class="elevation-2" style="border-radius: 12px;">
            <v-card-title class="font-weight-bold" style="background-color: #ffa409;">
              Structure du fichier Excel
            </v-card-title>
            
            <!-- Desktop view -->
            <table v-if="!isMobile()" class="simple-table">
              <thead>
                <tr>
                  <th v-for="header in headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in colonnes" :key="item.nom">
                  <td>{{ item.nom }}</td>
                  <td>{{ item.description }}</td>
                  <td class="example-cell">{{ item.exemple }}</td>
                  <td>{{ item.valeurs }} <span v-if="item.valeurs == 'Énumération'" class="tool" :data-tip="item.enum_content"><i class="material-icons" aria-hidden="true" data-nosnippet style="font-size: 20px;color: #ffa409;">&#xe000;</i></span>
                  </td>
                  <td>{{ item.obligatoire }}</td>
                </tr>
              </tbody>
            </table>


            <!-- Mobile view -->
            <div v-else class="pa-2">
              <v-card
                v-for="(item, index) in colonnes"
                :key="index"
                class="mb-3 pa-1"
                outlined
              >
                <div class="d-flex flex-column">
                  <div class="font-weight-bold mb-2">{{ item.nom }}</div>
                  <div class="grey--text-5 mb-2">{{ item.description }}</div>
                  <div class="grey lighten-4 pa-2 mb-2 rounded">
                    Exemple: <span class="font-weight-bold">{{ item.exemple }}</span>
                  </div>
                  <div class="caption">Format: {{ item.valeurs }} <span v-if="item.valeurs == 'Énumération'" class="tool" :data-tip="item.enum_content"><i class="material-icons" aria-hidden="true" data-nosnippet style="font-size: 20px;color: #ffa409;">&#xe000;</i></span></div>
                  <div class="grey-text-5 mb-2">{{ item.obligatoire }}</div>
                </div>
              </v-card>
            </div>
          </v-card>
        </section>

        <!-- Garanties disponibles -->
        <section class="mb-8 margin mt-5" v-if="isDesktop()">
          <v-layout row wrap>
            <!-- Nomenclatures des garanties -->
            <v-flex xs12 md6 class="pa-2">
              <v-card class="elevation-2" style="border-radius: 12px;">
                  <v-card-title class="mb-3 font-weight-bold" style="background-color: #ffa409;">
              {{ $t('faq_flotte.nomenclature_title') }}
            </v-card-title>
                <div v-for="(garantie, index) in garanties" :key="index" class="mb-4">
                  <v-icon small color="green" class="mr-2">mdi-check-circle</v-icon>
                  <span class="ml-3 body-2">{{ garantie }}</span>
                </div>
              </v-card>
            </v-flex>
               <!-- Catégorie -->
            <v-flex xs12 md6 class="pa-2">
               <v-card class="elevation-2" style="border-radius: 12px;">
                <v-card-title class="mb-3 font-weight-bold" style="background-color: #ffa409;">
              {{ $t('faq_flotte.option_garantie.title') }}
            </v-card-title>
                <h3 class="title font-weight-bold mb-4 ml-4" style="color: #ffa409;">{{ $t('faq_flotte.option_garantie.personne_transportee_label') }}</h3>
                <p class="body-2 mb-2 ml-4">Option 1</p>
                <ul class="ml-4">
                  <li>{{ $t('faq_flotte.option_garantie.deces_label') }} : <span>1 000 000 FCFA</span></li>
                  <li>{{ $t('faq_flotte.option_garantie.invalidite_label') }} : <span>1 000 000 FCFA</span></li>
                  <li>{{ $t('faq_flotte.option_garantie.Frais_médicaux') }} : <span>100 000 FCFA</span></li>
                </ul>
                 <p class="body-2 mb-2 ml-4">Option 2</p>
                <ul class="ml-4">
                  <li>{{ $t('faq_flotte.option_garantie.deces_label') }} : <span>2 000 000 FCFA</span></li>
                  <li>{{ $t('faq_flotte.option_garantie.invalidite_label') }} : <span>2 000 000 FCFA</span></li>
                  <li>{{ $t('faq_flotte.option_garantie.Frais_médicaux') }} : <span>200 000 FCFA</span></li>
                </ul>
                 <p class="body-2 mb-2 ml-4">Option 3</p>
                <ul class="ml-4">
                  <li>{{ $t('faq_flotte.option_garantie.deces_label') }} : <span>3 000 000 FCFA</span></li>
                  <li>{{ $t('faq_flotte.option_garantie.invalidite_label') }} : <span>3 000 000 FCFA</span></li>
                  <li>{{ $t('faq_flotte.option_garantie.Frais_médicaux') }} : <span>300 000 FCFA</span></li>
                </ul>
                 <h3 class="title font-weight-bold mb-4 ml-4" style="color: #ffa409;">{{ $t('faq_flotte.option_garantie.capital_avance_sur_recours') }}</h3>
                <p class="body-2 mb-2 ml-4">Choix : </p>
                <ul class="ml-4">
                  <li><span>500 000 FCFA</span></li>
                  <li><span>1 000 000 FCFA</span></li>
                  <li><span>Plus de 1 000 000 FCFA {{ $t('faq_flotte.option_garantie.nous_consulter') }}</span></li>
                </ul>
              </v-card>
               <v-card class="elevation-2" style="border-radius: 12px;">
                  <v-card-title class="mb-3 font-weight-bold" style="background-color: #ffa409;">
              {{ $t('faq_flotte.explication_categorie') }}
            </v-card-title>
                <div v-for="(garantie, index) in Categirie" :key="index" class="mb-3">
                  <v-icon small color="green" class="mr-2">mdi-check-circle</v-icon>
                  <span class="body-2 ml-3">{{ garantie }}</span>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </section>

        <section class="mb-8 margin mt-5" v-if="isMobile()">
          <v-layout row wrap>
            <!-- Nomenclatures des garanties -->
            <v-flex xs12 md6 class="pa-2">
              <v-card class="elevation-2" style="border-radius: 12px;">
                  <v-card-title class="mb-3 font-weight-bold" style="background-color: #ffa409;">
              {{ $t('faq_flotte.nomenclature_title') }}
            </v-card-title>
                <div v-for="(garantie, index) in garanties" :key="index" class="mb-4">
                  <v-icon small color="green" class="mr-2">mdi-check-circle</v-icon>
                  <span class="ml-3 body-2">{{ garantie }}</span>
                </div>
              </v-card>
            </v-flex>
               <!-- Catégorie -->
            <v-flex xs12 md6 class="pa-2">
               <v-card class="elevation-2" style="border-radius: 12px;">
                <v-card-title class="mb-3 font-weight-bold" style="background-color: #ffa409;">
              {{ $t('faq_flotte.option_garantie.title') }}
            </v-card-title>
                <h3 class="title font-weight-bold mb-4 ml-4" style="color: #ffa409;">{{ $t('faq_flotte.option_garantie.personne_transportee_label') }}</h3>
                <p class="body-2 mb-2 ml-4">Option 1</p>
                <ul class="ml-4">
                  <li>{{ $t('faq_flotte.option_garantie.deces_label') }} : <span>1 000 000 FCFA</span></li>
                  <li>{{ $t('faq_flotte.option_garantie.invalidite_label') }} : <span>1 000 000 FCFA</span></li>
                  <li>{{ $t('faq_flotte.option_garantie.Frais_médicaux') }} : <span>100 000 FCFA</span></li>
                </ul>
                 <p class="body-2 mb-2 ml-4">Option 2</p>
                <ul class="ml-4">
                  <li>{{ $t('faq_flotte.option_garantie.deces_label') }} : <span>2 000 000 FCFA</span></li>
                  <li>{{ $t('faq_flotte.option_garantie.invalidite_label') }} : <span>2 000 000 FCFA</span></li>
                  <li>{{ $t('faq_flotte.option_garantie.Frais_médicaux') }} : <span>200 000 FCFA</span></li>
                </ul>
                 <p class="body-2 mb-2 ml-4">Option 3</p>
                <ul class="ml-4">
                  <li>{{ $t('faq_flotte.option_garantie.deces_label') }} : <span>3 000 000 FCFA</span></li>
                  <li>{{ $t('faq_flotte.option_garantie.invalidite_label') }} : <span>3 000 000 FCFA</span></li>
                  <li>{{ $t('faq_flotte.option_garantie.Frais_médicaux') }} : <span>300 000 FCFA</span></li>
                </ul>
                 <h3 class="title font-weight-bold mb-4 ml-4" style="color: #ffa409;">{{ $t('faq_flotte.option_garantie.capital_avance_sur_recours') }}</h3>
                <p class="body-2 mb-2 ml-4">Choix : </p>
                <ul class="ml-4">
                  <li><span>500 000 FCFA</span></li>
                  <li><span>1 000 000 FCFA</span></li>
                  <li><span>Plus de 1 000 000 FCFA {{ $t('faq_flotte.option_garantie.nous_consulter') }}</span></li>
                </ul>
              </v-card>
            </v-flex>

            <v-flex xs12 md6 class="pa-2">
                 <v-card class="elevation-2" style="border-radius: 12px;">
                  <v-card-title class="mb-3 font-weight-bold" style="background-color: #ffa409;">
              {{ $t('faq_flotte.explication_categorie') }}
            </v-card-title>
                <div v-for="(garantie, index) in Categirie" :key="index" class="mb-3">
                  <v-icon small color="green" class="mr-2">mdi-check-circle</v-icon>
                  <span class="body-2 ml-3">{{ garantie }}</span>
                </div>
              </v-card>
            </v-flex>

            <v-flex xs12 md6 class="pa-2">
               <v-card class="elevation-2" style="border-radius: 12px;">
                <v-card-title class="mb-3 font-weight-bold" style="background-color: #ffa409;">
              {{ $t('faq_flotte.consigne_title') }}
            </v-card-title>
                <!-- <h3 class="title font-weight-bold mb-4 ml-4" style="color: #ff6b35;">{{ $t('faq_flotte.consigne_content[0]') }}</h3> -->
                <p class="body-2 mb-2 ml-4">{{ $t('faq_flotte.consigne_content[1]') }}</p>
                <p class="body-2 mb-4 ml-4">{{ $t('faq_flotte.consigne_content[2]') }}</p>
                <v-divider></v-divider>
                
                <div class="text-center">
                    <div class="text-center">
                        <button style="background:#ffa409;color:#000" type="button" class="mb-5 btn btn-primary" @click="downloadTemplateFlotte">{{ $t('devis.devis_auto.flotte_entreprise.download_flotte_excel_label')}}</button>
                        </div>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </section>

         
        <section class="mb-8 margin">
          <v-layout row wrap>
             <!-- Catégorie -->
            <v-flex v-if="isDesktop()" xs12 md6 class="pa-2" style="margin-top: -33%;">
                <v-card class="mt-5 elevation-2" style="border-radius: 12px;">
                <v-card-title class="mb-3 font-weight-bold" style="background-color: #ffa409;">
              {{ $t('faq_flotte.consigne_title') }}
            </v-card-title>
                <!-- <h3 class="title font-weight-bold mb-4 ml-4" style="color: #ff6b35;">{{ $t('faq_flotte.consigne_content[0]') }}</h3> -->
                <p class="body-2 mb-2 ml-4">{{ $t('faq_flotte.consigne_content[1]') }}</p>
                <p class="body-2 mb-4 ml-4">{{ $t('faq_flotte.consigne_content[2]') }}</p>
                <v-divider></v-divider>
                <div class="text-center">
                    <div class="text-center">
                        <button style="background:#ffa409;color:#000" type="button" class="mb-5 btn btn-primary" @click="downloadTemplateFlotte">{{ $t('devis.devis_auto.flotte_entreprise.download_flotte_excel_label')}}</button>
                        </div>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </section>

        <div v-if="dialogDownloadFile" class="loading-state">
            <div class="loading"></div>
            <span class="ml-3 loading-text">{{ $t('faq_flotte.download_file') }}</span>
        </div>

        <v-layout v-responsive.lg.xl>
                  <!-- FAQ SECTION -->
                  <FaqSection></FaqSection>
        </v-layout>

        <v-layout v-responsive.sm.xs>
            <!-- FAQ SECTION -->
            <FaqSectionMobile></FaqSectionMobile>
        </v-layout>
    </v-container>
</template>

<script>
    import FaqSection from './faq_section_desktop.vue'
    import FaqSectionMobile from './faq_section_mobile.vue'
    import colonneGaranties from '../../common/colonneGaranties.json'

    export default {
         components: {
            FaqSection,
            FaqSectionMobile
        },
        data() {
            return {
                dialogDownloadFile : false,
                description: 'Assuraf – faq flotte',
                HideDive: true,
                HideDive1: false,
                HideDive2: false,
                tabs: null,
                isHidden: true,
                //
                etapes: [
                    {
                        //{{ $t('faq_flotte.download_file') }}
                      titre: 'Étape 1',
                      description: 'Télécharger le modèle Excel',
                      icon: 'download',
                      color: '#2196f3'
                    },
                    {
                      titre: 'Étape 2', 
                      description: 'Remplir les colonnes obligatoires',
                      icon: 'note',
                      color: '#ff9800'
                    },
                    {
                      titre: 'Étape 3',
                      description: 'Vérifier les formats et garanties',
                      icon: 'format_list_numbered',
                      color: '#9c27b0'
                    },
                    {
                      titre: 'Étape 4',
                      description: 'Importer le fichier',
                      icon: 'upload',
                      color: '#4caf50'
                    }
                ],
                headers: [
                  { text: 'Nom colonne', value: 'nom', sortable: false, width: '15%' },
                  { text: 'Description', value: 'description', sortable: false, width: '25%' },
                  { text: 'Exemple', value: 'exemple', sortable: false, width: '20%' },
                  { text: 'Format colonne', value: 'valeurs', sortable: false, width: '20%' },
                  { text: 'Obligation', value: 'Obligation', sortable: false, width: '20%' }
                ],
                colonnes : colonneGaranties,
                // colonnes: [
                //   {
                //     nom: 'marque',
                //     description: 'Marque',
                //     exemple: 'Toyota',
                //     valeurs: 'Texte libre',
                //     obligatoire : 'Obligatoire'
                //   },
                //   {
                //     nom: 'model',
                //     description: 'Modèle',
                //     exemple: 'RAV4',
                //     valeurs: 'Texte libre',
                //     obligatoire : 'Obligatoire'
                //   },
                //   {
                //     nom: 'immatriculation',
                //     description: 'Plaque du véhicule',
                //     exemple: "DK-1234-AA, DK-0000-AA",
                //     valeurs: 'Texte intermédiaire',
                //     obligatoire : 'Obligatoire'
                //   },
                //   {
                //     nom: 'force',
                //     description: 'Nombre de chevaux',
                //     exemple: '13',
                //     valeurs: 'Nombre entier',
                //     obligatoire : 'Obligatoire'
                //   },
                //   {
                //     nom: 'carburation',
                //     description: 'Carburant',
                //     exemple: 'Essence, Diésel',
                //     valeurs: 'Énumération',
                //     obligatoire : 'Obligatoire',
                //     enum_content : "Essence, Diésel, Hybride, Électrique"
                //   },
                //   {
                //     nom: 'nbplace',
                //     description: 'Nombre de place(s)',
                //     exemple: '5',
                //     valeurs: 'Nombre entier',
                //     obligatoire : 'Obligatoire'
                //   },
                //   {
                //     nom: 'tonnage',
                //     description: 'Poids ou Capacité de charge',
                //     exemple: '3,5 Tonnes',
                //     valeurs: 'Énumération',
                //     obligatoire : 'Obligatoire si le véhicule est de catégorie 2 ou 3',
                //     enum_content : "3,5 Tonnes, Plus de 3,5 Tonnes"
                //   },
                //   {
                //     nom: 'volumetrie2_roues',
                //     description: 'Volumétrie (2 Roues)',
                //     exemple: '125 (cm3)',
                //     valeurs: 'Nombre entier',
                //     obligatoire : 'Obligatoire pour 2 Roues'
                //   },
                //   {
                //     nom: 'categorie',
                //     description: 'catégorie du véhicule (VP, VU, moto)',
                //     exemple: 'Catégorie 1',
                //     valeurs: "Énumération",
                //     obligatoire : "Obligatoire",
                //     enum_content : "categorie 1, catégorie 2, catégorie 3, catégorie 5"
                //   },
                //   {
                //     nom: 'DateCircule',
                //     description: 'Date 1ère mise en circulation',
                //     exemple: '12/02/2023',
                //     valeurs: 'Format JJ/MM/AAA',
                //     obligatoire : 'Obligatoire'
                //   },
                //   {
                //     nom: 'carosserie',
                //     description: 'Carosserie du véhicule',
                //     exemple: 'carosserie tourisme',
                //     valeurs: 'Énumération',
                //     obligatoire : 'Obligatoire',
                //     enum_content : "carosserie tourisme, autres carosseries"
                //   },
                //    {
                //     nom: 'optionutilitaire',
                //     description: 'Les options pour la catégorie 2 et 3',
                //     exemple: 'Pour Compte',
                //     valeurs: 'Énumération',
                //     obligatoire : 'Obligatoires pour les catégories 2 et 3',
                //     enum_content : "Pour Compte, Pour Tiers"
                //   },
                //   {
                //     nom: 'garanties',
                //     description: 'Garanties',
                //     exemple: 'RESPONSABILITE CIVILE',
                //     valeurs: "RESPONSABILITE CIVILE, VOL, INDENDIE",
                //     obligatoire : 'Obligatoire'
                //   },
                //     {
                //     nom: 'valeur',
                //     description: 'Valeur actuelle sur le marché',
                //     exemple: '20000000',
                //     valeurs: 'Nombre entier',
                //     obligatoire : 'Obligatoire pour les garanties tièrces (complète ou collision)'
                //   },
                //   {
                //     nom: 'valeur_venale',
                //     description: 'Valeur à neuf sur le marché',
                //     exemple: '25000000',
                //     valeurs: 'nombre entier',
                //     obligatoire : 'Obligatoire'
                //   },
                //   {
                //     nom: 'option_Individuel_Accident',
                //     description: 'Les options pour la garantie Individuelle Accident',
                //     exemple: 'Option 1',
                //     valeurs: 'Énumération',
                //     obligatoire : 'Obligatoires pour la garantie Individuelle Accident',
                //     enum_content : "Option 1, Option 2, Option 3"
                //   }
                // ],
                garanties: [
                  'RESPONSABILITE CIVILE (obligatoire)',
                  'VOL',
                  'DEFENSE ET RECOURS',
                  'INDENDIE',
                  'PERSONNES TRANSPORTEES',
                  'AVANCE SUR RECOURS',
                  'BRIS DE GLACES',
                  'TIERCE COMPLETE',
                  'TIERCE COLLISION',
                  'TIERCE PLAFONNEE',
                  'INDIVIDUEL ACCIDENT'
                ],
                 Categirie: [
                  'Catégorie 1 : VP, Tourisme',
                  'Catégorie 2 : Véhicule utilitaire, avec option utilitaire : Pour Compte',
                  'Catégorie 3 : Véhicule utilitaire, avec option utilitaire : Pour Tiers',
                  'Catégorie 4 : Non pris en compte pour le moment',
                  'Catégorie 5 : 2 Roues, Moto, Sidecar, etc'
                ],
            }
        },
        metaInfo () {
            return {
                meta: [
                    { charset: 'utf-8' },
                    { name: 'keywords', content: 'aide à la saisie, saisie flotte'},
                    { hid: 'description', name: 'description', content: this.description}
                ]
            }
        },
        methods: {
            downloadTemplateFlotte(){
                this.dialogDownloadFile = true
                // Get template file URL
                let url = "https://production-assuraf-api-files.nyc3.digitaloceanspaces.com/uploads/Template_flotte.xlsx"
      
                // Download file in same window
                //window.location.href = url;
                setTimeout(() => (
                    this.dialogDownloadFile = false,
                    window.location.href = url), 2000);
                 // Prevent default navigation
                  return false;
                },
            isMobile: function () {
                if (screen.width <= 760) {
                    return true;
                } else {
                    return false;
                }
            },
            isDesktop: function () {
                if (screen.width > 760) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        mounted(){
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/less/config";
    @import "../../assets/css/devis_css.css";

    img {
        width: 100%;
        height: 300px;
    }

    .mamadou {
        width: 145px;
        height: 600px;
    }


    .article {
        /*margin-left: 7.5%;*/
        padding: 1%;
        text-align: justify;
        font-size: 16px;
        line-height: 30px;
        font-family: "Myriad Pro Regular" !important;
    }

    .img-box {
        width: 10%;
        height: 15%;
    }

    .text-sm-left {
        font-family: "Open-Sans" !important;
        font-size: 16px;
        padding: 2%;
        width: 498px;
    }

    .text-xs-right {
        font-family: "Open-Sans" !important;
        padding: 2%;
        padding-top: -1000px;
        margin-left: 700px;
        font-size: 16px;
        width: 498px;
    }

    /*notre equipe*/
    h2 {
        color: #333;
        text-align: center;
        text-transform: uppercase;
        font-family: "Open-Sans", sans-serif;
        font-weight: bold;
        position: relative;
        margin: 30px 0 60px;
    }


    .valeur .description {
        font-size: 14px;
        color: #FFFFFF;
        line-height: 26px;
        text-indent: 30px;
        position: relative;
        margin-top: -29px;
        margin-left: 450px;
    }

    .primary--text {
        font-family: Myriad Pro;
        font-weight: bold;
        color: #000000;
        font-size: 20px;

        .v-tabs__item {
            color: black;

        }

    }

    .col-center {
        margin: 0 auto;
        float: none !important;
    }

    .carousel {
        margin: 50px auto;
        padding: 0 70px;
    }

    .carousel .item {
        color: #999;
        font-size: 14px;
        text-align: center;
        overflow: hidden;
        min-height: 290px;
    }

    .carousel .item .img-box {
        width: 175px;
        height: 175px;
        margin: 0 auto;
        padding: 5px;
        border: 1px solid #ddd;
        border-radius: 50%;
    }

    .carousel .img-box img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 50%;
    }

    .carousel .testimonial {
        padding: 30px 0 10px;
    }

    .carousel .overview {
        font-style: italic;
    }

    .carousel .overview b {
        text-transform: uppercase;
        color: #7AA641;
    }

    .carousel .carousel-control {
        width: 40px;
        height: 40px;
        margin-top: -20px;
        top: 50%;
        background: none;
    }

    .carousel-control i {
        font-size: 68px;
        line-height: 42px;
        position: absolute;
        display: inline-block;
        color: rgba(0, 0, 0, 0.8);
        text-shadow: 0 3px 3px #e6e6e6, 0 0 0 #000;
    }

    .carousel .carousel-indicators {
        bottom: -40px;
    }

    .carousel-indicators li, .carousel-indicators li.active {
        width: 10px;
        height: 10px;
        margin: 1px 3px;
        border-radius: 50%;
    }

    .carousel-indicators li {
        background: #999;
        border-color: transparent;
        box-shadow: inset 0 2px 1px rgba(0, 0, 0, 0.2);
    }

    .carousel-indicators li.active {
        background: #555;
        box-shadow: inset 0 2px 1px rgba(0, 0, 0, 0.2);
    }

    .text-assuraf {
        color: #ffa409;
    }

    .title-border {
        border-left: 5px solid #ffa409;
        padding-left: 0.6em;
        line-height: 0.5em;
    }

    span {
        font-weight: bold
    }

    strong {
        color: rgb(101, 101, 235);
        font-family: 'Times New Roman', Times, serif
    }

    .georgia {
        font-family: Georgia !important;
    }
    .policeLato {
      font-family: Lato, "Helvetica Neue", Arial, sans-serif;
    }
    .paralax-cover-image {
      background-image: url('../../assets/img/assurance/cgv.jpg');
      position: relative;
      background-size: contain!important;
      background-position: 50%;
      min-height: 230px;
      width: 100%;
      margin: 0 0 0;
      display: flex;
      /*padding: 20px;*/
      align-items: center;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;

    }
    .paralax-cover-image p {
      color: rgb(255, 255, 255);
      font-size: 20px;
      font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
      color: #fff;
      font-size: 2em;
      line-height: 1.25;
      z-index: 1;
      margin-bottom: 0;
      max-width: 610px;
      text-align: center;
      margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
      background-attachment: fixed;
      background-position: 50% 40px;
    }



    .paralax-cover-image_mobile {
      background-image: url('../../assets/img/assurance/cgv_mobile.jpg');
      position: relative;
      background-size: contain;
      background-position: 50%;
      min-height: 150px;
      width: 100%;
      margin: 0 0 0;
      display: flex;
      //padding: 20px;
      align-items: center;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
      color: rgb(255, 255, 255);
      font-size: 20px;
      font-weight: 300;
      padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
      color: #fff;
      font-size: 2em;
      line-height: 1.25;
      z-index: 1;
      margin-bottom: 0;
      max-width: 610px;
      text-align: center;
      margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
    //   background-attachment: fixed;
      background-position: 100% 40px;
    }

     table {
        border-collapse: collapse;
        width: 80%;
        font-family: Arial, sans-serif;
    }
    th {
     

        // background-color: orange;
        // color: black;
        // font-weight: bold;
        // text-align: left;
        // padding: 8px;
        // border: 1px solid #000;
    }
    .table.v-table thead th {
     border: 1.5px solid!important;
    font-size: 15px!important;
    font-weight: bold;
    color: #000;
    }
    td {
        border: 1px solid #000;
        padding: 8px;
    }
    .red {
        color: red;
        font-weight: bold;
    }

    tr {
      border: 1.5 solid;
    }
/* Responsive : transformer le tableau en cartes sur mobile */
@media (max-width: 768px) {
  table, thead, tbody, th, td, tr {
    display: block;
    width: 100%;
  }

  thead {
    display: none; /* on cache l'entête */
  }

  // tr {
  //   margin-bottom: 15px;
  //   background: #fff;
  //   border-radius: 8px;
  //   padding: 12px;
  //   box-shadow: 0 2px 5px rgba(0,0,0,0.1);
  // }

  td {
    border: none !important;
    padding: 8px 0;
    text-align: left;
  }

  td::before {
    content: attr(data-label);
    font-weight: bold;
    display: block;
    color: #555;
    margin-bottom: 4px;
  }
}


.policeLato {
  font-family: 'Lato', sans-serif;
}

.v-card {
  transition: all 0.3s ease;
}

.v-card:hover {
  transform: translateY(-2px);
}

code {
  font-size: 0.875rem;
}

.v-data-table > tbody tr:nth-child(even) {
  background-color: #fafafa;
 
}

.v-data-table > tbody tr:hover {
  background-color: #f0f0f0 !important;
   color: #000;
}

.margin {
    margin-left: 9.5%;
    margin-right: 9.5%;
  }
  
  .margin_mobile {
    margin-left: 9.5%;
    margin-right: 9.5%;
  }



.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  
}
.loading {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 5px solid #ddd;
  border-top-color: #ffa409;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
.loading-text{
    color: rgb(255, 255, 255);
    font-weight: bold;
}
.underline_bar{
        height:4px;
        width: 150px;
        background:#ffa409;
    }
    .underline_bar_for_number{
        height:4px;
        width: 150px;
        background:#fff;
    }
    .titre_for_desktop{
        color: #2b2b2b;
        font-size: 25px!important;
        font-weight: bold;
        text-align: center;
    }



              .simple-table {
                width: 100%;
                border-collapse: collapse;
                //margin: 1rem 0;
              }
              
              .simple-table th,
              .simple-table td {
                padding: 12px;
                text-align: left;
                border: 1px solid #ddd;
              }

              .simple-table th {
                background-color: #f5f5f5;
                font-weight: bold;
              }

              .example-cell {
                background-color: #f0f0f0;
                border-radius: 4px;
              }


                /*== start of code for tooltips ==*/
  .tool {
    cursor: help;
    position: relative;
  }
  
  
  /*== common styles for both parts of tool tip ==*/
  .tool::before,
  .tool::after {
    left: 50%;
    opacity: 0;
    position: absolute;
    z-index: -100;
  }
  
  .tool:hover::before,
  .tool:focus::before,
  .tool:hover::after,
  .tool:focus::after {
    opacity: 1;
    transform: scale(1) translateY(0);
    z-index: 100;
  }
  
  
  /*== pointer tip ==*/
  .tool::before {
    border-style: solid;
    border-width: 1em 0.75em 0 0.75em;
    border-color: #565C61 transparent transparent transparent;
    bottom: 105%;
    content: "";
    margin-left: -0.5em;
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26), opacity .65s .5s;
    transform: scale(.6) translateY(-90%);
  }
  
  .tool:hover::before,
  .tool:focus::before {
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
  }
  
  
  
  /*== speech bubble ==*/
  .tool::after {
    background: #565C61;
    border-radius: .25em;
    bottom: 120%;
    color: #EDEFF0;
    font-size: 15px;
    content: attr(data-tip);
    margin-left: -8.75em;
    padding: 1em;
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26) .2s;
    transform: scale(.6) translateY(50%);
    width: 17.5em;
  
  }
  
  .tool:hover::after,
  .tool:focus::after {
    transition: all .65s cubic-bezier(.84, -0.18, .31, 1.26);
  }
  
  @media (max-width: 760px) {
    .tool::after {
      font-size: 1em;
     // margin-left: -5em;
      width: 20em;
    }
  }

</style>
